module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc9",
      "id": "dd9"
    }
  }, [_c('i', [_vm._v("January 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary7"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0012-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Remember me, my God, for good")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0012-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("hus says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(": “I remember you, the kindness of your youth, the love of your betrothal, when you went after Me in the wilderness.” • I will remember My covenant with you in the days of your youth, and I will establish an everlasting covenant with you. • I will visit you and perform My good word toward you. . . . For I know the thoughts that I think toward you, says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", thoughts of peace and not of evil, to give you a future and a hope.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-05-6"
    }
  }, [_vm._v("As the heavens are higher than the earth, so are My ways higher than your ways, and My thoughts than your thoughts. • I would seek God, and to God I would commit my cause—who does great things, and unsearchable, marvelous things without number. • Many, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" my God, are Your wonderful works which You have done; and Your thoughts toward us cannot be recounted to You in order; if I would declare and speak of them, they are more than can be numbered.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EH")]), _vm._v(". 5:19; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(". 2:2; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ZEK")]), _vm._v(". 16:60; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(". 29:10–11; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 55:9; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")]), _vm._v(" 5:8–9; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 40:5")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary7"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0012-08-10"
    }
  }, [_c('span', [_c('i', [_vm._v("I will not leave you nor forsake you")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0012-09-12"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("N")]), _vm._v("ot a word failed of any good thing which the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" had spoken to the house of Israel. All came to pass. • God is not a man, that He should lie, nor a son of man, that He should repent. Has He said, and will He not do? Or has He spoken, and will He not make it good?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-10-15"
    }
  }, [_vm._v("Therefore know that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God, He is God, the faithful God who keeps covenant and mercy for a thousand generations with those who love Him and keep His commandments. • He will ever be mindful of His covenant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-10-16"
    }
  }, [_vm._v("Can a woman forget her nursing child, and not have compassion on the son of her womb? Surely they may forget, yet I will not forget you. See, I have inscribed you on the palms of My hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-10-17"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God in your midst, the Mighty One, will save; He will rejoice over you with gladness, He will quiet you with His love, He will rejoice over you with singing.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSH")]), _vm._v(". 1:5; 21:45; N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UM")]), _vm._v(". 23:19; D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUT")]), _vm._v(". 7:9; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 111:5; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 49:15–16; Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPH")]), _vm._v(". 3:17")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3749a0e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter9.vue
// module id = 90
// module chunks = 0